export default __webpack_public_path__ + "static/bomb-message-8b56992f3353126fc4872d7e99bcba99.png";